// @flow
import React from 'react';
import cx from 'classnames';
import { imageURL, numberWithCommas } from 'lib/common';
import Button from 'components/common/Button';
import { Link } from 'react-router-dom';
import './OrderRefundTemplate.scss';

type Props = {
  order: any,
};

const reasonCategories = [
  {
    id: 1,
    label: '고객 변심'
  },
  {
    id: 2,
    label: '제품 하자'
  }
];

const OrderRefundTemplate = (props: Props) => (
  <div className="OrderRefundTemplate">
    <div className="order-request-refund">

      <h2 className="with-back-button">
        환불 요청
      </h2>
      <Link to={`/orders/${props.order.id}`} className="back-to-orders">주문 내역으로 돌아가기</Link>

      {!props.order.items.length &&
      <p className="order-has-no-refundable-item">
        환불 가능한 상품이 하나도 없습니다.
      </p>
      }

      {!!props.order.items.length &&
      <div className="order-refund-process">

        <div className="order-refundable-items cart-items">

          <h3>
            환불 요청 품목
          </h3>

          <table className="table">
            <thead>
              <tr>
                <th colSpan="2">상품 정보</th>
                <th>환불 수량</th>
                <th>환불 금액</th>
              </tr>
            </thead>
            <tbody>
              {props.order.items.map((item, index) => (
                <tr key={item.id} className={cx('cart-item', { inactive: !item.refunded })} data-item={item.id}>
                  <td className="cart-item-thumbnail-container">
                    <img
                      src={item.product ? imageURL(item.product.thumbnail, 120, 120) : ''}
                      className="cart-item-thumbnail"
                      alt={'products'}
                    />
                  </td>
                  <td className="cart-item-name">

                    <div className="cart-item-summary">
                      <h3 className="cart-item-name">
                        {item.product.name}
                      </h3>
                      <ul>
                        {item.variant && item.variant.types.length > 0 && (
                          <li className="cart-item-option">
                            <span className="cart-entity-label">카탈로그 번호</span>
                            {item.variant.sku}
                          </li>
                        )}
                        {item.productPrice && (
                          <li className="cart-item-shipping-method">
                            <span className="cart-entity-label">설명</span>
                            {item.productPrice.description}
                          </li>
                        )}
                        {item.productPrice && (
                          <li className="cart-item-shipping-method">
                            <span className="cart-entity-label">단위</span>
                            {item.productPrice.unit}
                          </li>
                        )}
                      </ul>
                      {item.refunded ?
                        <Button
                          theme="outline"
                          color="blue"
                          className="toggle-item-selection button-tiny skeleton"
                          onClick={() => props.onRemoveRefund(index)}
                        >
                          환불 내역에 제거
                        </Button>
                      :
                        <Button
                          theme="outline"
                          color="blue"
                          className="toggle-item-selection button-tiny skeleton"
                          onClick={() => props.onAddRefund(index)}
                        >
                          환불 내역에 추가
                        </Button>
                      }
                    </div>

                  </td>
                  <td className="cart-item-quantity">
                    <span className="cart-item-quantity-value">
                      <input
                        type="number"
                        name="refundQuantity"
                        min="0"
                        max={item.quantity}
                        value={item.refundQuantity}
                        onChange={(e) => props.onRefundQuantity({ index, quantity: Number(e.target.value) })}
                        className="quantity"
                      />
                    </span>
                  </td>
                  <td className="cart-item-refund-amount">
                    {item.refundQuantity &&
                      `${numberWithCommas(item.refundQuantity * item.price.sale.raw)}원`
                    }
                  </td>
                </tr>
              ))}

            </tbody>

          </table>

        </div>

        <div className="order-refund-summary">

          <h3>
            환불 정보
          </h3>

          <div className="refund-reason-detail form">
            <h4>
              환불 사유
            </h4>
            <select className="refund-category" name="reasonCategory" onChange={props.handleChange}>
              <option name="reasonCategory" value="" disabled selected>
                환불 사유 선택
              </option>
              {reasonCategories.map((category, index) => (
                <option key={category.id} name="reasonCategory" value={category.label}>
                  {category.label}
                </option>
              ))}
            </select>
            <textarea
              name="reason"
              value={props.reason}
              className="refund-reason"
              placeholder="자세한 환불 이유를 입력해주세요."
              onChange={props.handleChange}
            />
          </div>

          <div className="refund-total-summary">
            <h4>
              환불 금액
            </h4>
            <p className="requires-refund-reason">
              환불 사유 선택후에 계산됩니다.
            </p>
            <table className="refund-total-detail">
              <tbody>
                <tr className="refund-items-total">
                  <th>상품 환불액</th>
                  <td>
                    {numberWithCommas(props.order.items
                      .filter(item => item.refunded)
                      .reduce((accumulator, currentItem) => {
                        return accumulator + (currentItem.refundQuantity * currentItem.price.sale.raw);
                      }, 0))
                    }원
                  </td>
                </tr>
                <tr className="refund-shipping-total">
                  <th>배송비 환불액</th>
                  {props.reasonCategory === '제품 하자' ?
                    <td>{numberWithCommas(props.order.total.shipping.fee.sale.raw)}원</td> :
                    <td>0원</td>
                  }
                </tr>
                <tr className="refund-tax">
                  <th>부가세</th>
                  <td>
                    {numberWithCommas(Math.floor((props.order.items
                      .filter(item => item.refunded)
                      .reduce((accumulator, currentItem) => {
                        return accumulator + (currentItem.refundQuantity * currentItem.price.sale.raw);
                      }, 0) + Number(props.reasonCategory === '제품 하자' ? props.order.total.shipping.fee.sale.raw : 0)) * 0.1))
                    }원
                  </td>
                </tr>
                <tr className="refund-total">
                  <th>총계</th>
                  <td>
                    {numberWithCommas(Math.floor((props.order.items
                      .filter(item => item.refunded)
                      .reduce((accumulator, currentItem) => {
                        return accumulator + (currentItem.refundQuantity * currentItem.price.sale.raw);
                      }, 0) + Number(props.reasonCategory === '제품 하자' ? props.order.total.shipping.fee.sale.raw : 0)) * 1.1))
                    }원
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Button className="button request-refund" onClick={props.onOrderRefund}>
            환불 요청하기
          </Button>

        </div>

      </div>
      }

    </div>
  </div>
);

export default OrderRefundTemplate;



// WEBPACK FOOTER //
// ./src/components/order/OrderRefundTemplate/OrderRefundTemplate.js